'use strict';

var React = require('react'),
    ReactDOM = require('react-dom'),
    Popover = require('../Popover/Popover');

var Tooltip = React.createClass({
    displayName: 'Tooltip',


    positions: {
        START: "START",
        END: "END",
        MIDDLE: "MIDDLE"
    },

    propTypes: {
        delaymsecs: React.PropTypes.number
    },

    getInitialState: function getInitialState() {
        return {
            open: false,
            openTimeout: null
        };
    },

    getDefaultProps: function getDefaultProps() {
        return {
            showOnHover: null,
            delaymsecs: 500,
            openPosition: undefined //"HORIZINTAL VERTICAL" values, can be START/MIDDLE/END   START for horizental means TOP, START for vertical means TOP, etc...
        };
    },

    onLeave: function onLeave() {
        this.lastX = undefined;
        this.lastY = undefined;

        if (this.state.openTimeout) {
            clearTimeout(this.state.openTimeout);
        }

        var newState = {
            openTimeout: null,
            open: false
        };

        this.setState(newState);
    },

    onMove: function onMove(event) {
        this.lastX = event.clientX;
        this.lastY = event.clientY;
    },

    onEnter: function onEnter(event) {
        event.persist();

        var self = this;
        if (this.props.delaymsecs == 0) {
            self.__openTooltip(event);
        } else {
            var openTimeout = setTimeout(function () {
                self.__openTooltip(event);
            }, this.props.delaymsecs);

            this.setState({ openTimeout: openTimeout });
        }
    },

    __openTooltip: function __openTooltip(event) {
        this.setState({
            open: true
        });

        this._updatePosition(this.lastX || event.clientX, this.lastY || event.clientY);
    },

    _updatePosition: function _updatePosition(mouseX, mouseY) {
        var tooltip = this.refs['tooltip'];
        if (tooltip) {
            var wrapEl = ReactDOM.findDOMNode(this.refs['children-wrap']);
            var tooltipEl = ReactDOM.findDOMNode(tooltip);

            var wrapBox = wrapEl.getBoundingClientRect();

            var position = this._parsePosition();

            if (position) {
                var left = 0;
                var top = 0;
                switch (position.horizental) {
                    case this.positions.START:
                        left = -(tooltip.clientWidth / 2);
                        break;
                    case this.positions.MIDDLE:
                        left = wrapBox.width / 2 - tooltip.clientWidth / 2;
                        break;
                    case this.positions.END:
                        left = wrapBox.width + tooltip.clientWidth / 2;
                        break;
                }

                switch (position.vertical) {
                    case this.positions.START:
                        top = -(tooltip.clientHeight / 2);
                        break;
                    case this.positions.MIDDLE:
                        top = wrapBox.height / 2 - tooltip.clientHeight / 2;
                        break;
                    case this.positions.END:
                        top = wrapBox.height;
                        break;
                }

                tooltipEl.style.left = left + 5 + "px";
                tooltipEl.style.top = top + 10 + "px";
            } else {
                //Open at mouse position
                var extraWidth = mouseX - wrapBox.left;
                var extraHeight = mouseY - wrapBox.top;

                tooltipEl.style.top = extraHeight + tooltip.clientHeight / 2 + "px";
                tooltipEl.style.left = extraWidth - tooltip.clientWidth / 2 + "px";
            }
        }
    },

    _parsePosition: function _parsePosition() {
        if (this.props.openPosition) {
            var splited = this.props.openPosition.trim().split(' ');
            var strHorizental = splited[0];
            var strVertical = strHorizental;
            if (splited.length > 1) {
                strVertical = splited[1];
            }

            if (this.positions[strHorizental.trim().toUpperCase()] && this.positions[strVertical.trim().toUpperCase()]) {
                return {
                    horizental: this.positions[strHorizental.trim().toUpperCase()],
                    vertical: this.positions[strVertical.trim().toUpperCase()]
                };
            }

            return undefined;
        }
    },

    render: function render() {
        var className = "tooltip-container " + (this.props.className ? this.props.className : "");

        var tooltipContent;
        if (this.state.open && this.props.showOnHover) {
            tooltipContent = React.createElement(
                'div',
                { className: 'tooltip', ref: 'tooltip' },
                React.createElement('div', { className: 'arrow' }),
                this.props.showOnHover
            );
        }

        return React.createElement(
            'div',
            { className: className, onMouseEnter: this.onEnter, onMouseLeave: this.onLeave, onMouseMove: this.onMove },
            React.createElement(
                'div',
                { ref: 'children-wrap' },
                this.props.children
            ),
            tooltipContent
        );
    }

});

module.exports = Tooltip;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fdna-common-components/dist/components/Tooltip/Tooltip.js
// module id = 85
// module chunks = 0 1 2 3 5 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 25 26